import angular from "angular";

angular.module('app')
    .component('cabinetUserNotifications', {
        template: require('./cabinet-user-notifications.html'),
        controller: ['$http', 'Notifier', '$rootScope', '$uibModal','trans', controller],
        bindings: {
            user: '<',
        }
    });


function controller($http, Notifier, $rootScope, $uibModal,trans) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.status = null;
    $ctrl.notifications = null;
    $ctrl.perPage = 15;
    $ctrl.lang = null;

    $ctrl.$onInit = function () {
        $ctrl.getNotificationsList();

    };

    $ctrl.getNotificationsList = function () {

        let params = {
            page: $ctrl.page,
            status: $ctrl.status,
            perPage: $ctrl.perPage,
        };

        $http.get(`/cabinet/notifications-list`, {params}).then(
            function (response) {
                $ctrl.notifications = response.data.data;
                $ctrl.total = response.data.total;
            },
            function (error) {
                Notifier.error(trans("An error occurred with the text: :error") + error.data.message, 2);
            })
    };

    $ctrl.deleteNotification = function (notification, index) {
        if (notification.deleteLoading) {
            return;
        }
        $http.delete(`/cabinet/notifications/${notification.id}`).then(
            function (response) {
                $ctrl.notifications.splice(index, 1);
                if (!notification.read_at) {
                    $rootScope.$emit('ReduceCountNotifications', {count: 1});
                }
                Notifier.success(trans('Successfully deleted'), 2);
            },
            function (error) {
                notification.deleteLoading = false;
                Notifier.error(trans("An error occurred with the text: :error") + error.data.message, 2);
            });
    };

    $ctrl.openNotification = function (notification) {
        if (!notification.read_at) {
            $http.get('/cabinet/notifications/' + notification.id).then(
                function () {
                    notification.read_at = Date.now();
                    $rootScope.$emit('ReduceCountNotifications', {count: 1});
                    },
                function (error) {
                    Notifier.error(error.data.message)
                }
                );
        }

        $uibModal
            .open({
                component: notification.notification_data.component_name,
                resolve: {
                    notification: function () {
                        return notification;
                    }
                },
                windowTemplateUrl: 'vertical-centered-modal.html',
            });
    };
}



